import { RouteRecordRaw, createRouter, createWebHashHistory } from "vue-router";
import settingsRoutes from "../components/settings/routes";
import myPortfolioRoutes from '../components/my-portfolio/routes';
import homepageRoutes from '../components/homepage/routes';
import signUpRoutes from '../components/sign-up/routes';
import signInRoutes from '../components/sign-in/routes';
import registrationRoutes from '../components/registration/routes';
import myServicesRoutes from "../components/my-services/routes";
import emailVerificationRoutes from "../components/email-verification/routes";
import resetPasswordRoutes from "../components/reset-password/routes";
import myAdvertisementsRoutes from "../components/my-advertisements/routes";

const routes: RouteRecordRaw[] = [
    ...homepageRoutes,
    ...settingsRoutes,
    ...myPortfolioRoutes,
    ...signUpRoutes,
    ...signInRoutes,
    ...registrationRoutes,
    ...myServicesRoutes,
    ...emailVerificationRoutes,
    ...resetPasswordRoutes,
    ...myAdvertisementsRoutes,
    {
        path: '/',
        redirect: { name: 'post-login-dashboard' }
    }
]

export const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router;